import axios from "axios"
import {
  MOD_PRODUCT,
  ADD_PRODUCT_MODE,
  DELETE_PRODUCT_MODE,
  EDIT_PRODUCT_MODE,
  PRODUCT_SELECTED,
  CREATE_PRODUCT,
  GET_PRODUCTS,
  RESET_PRODUCT_SELECTED
} from "redux/reducers/productsCatalog/productsCatalogReducer"
import { START_REQUEST_SEARCH, STOP_REQUEST_SEARCH, SET_SNACKBAR_SEARCH } from "redux/reducers/search/searchReducer";

export const getProductsCatalog = (token) => {
  const url = `${process.env.REACT_APP_URL}/crm/products`
  const headers = { Authorization: token }
  let payload = {}
  return async( dispatch ) => {
    dispatch({ type: START_REQUEST_SEARCH })
    await axios.get(url, {headers}).then(resp => {
      payload = {
        type: GET_PRODUCTS,
        payload: resp.data
      }
      dispatch(payload)
    }).catch(error => {
      const err = error.response?.data?.message?.error
      dispatch({
        type: SET_SNACKBAR_SEARCH,
        payload: { message: err ? err : 'Error en el servidor', color: 'danger' }
      })
    })
    dispatch({ type: STOP_REQUEST_SEARCH })
  }
}

export const productSelected = (id) => {
  return {
    type: PRODUCT_SELECTED,
    payload: id
  }
}

export const addProductMode = () => {
  return {
    type: ADD_PRODUCT_MODE,
  }
}

export const editProductMode = () => {
  return {
    type: EDIT_PRODUCT_MODE,
  }
}

export const deleteProductMode = () => {
  return {
    type: DELETE_PRODUCT_MODE,
  }
}

export const resetProductSelected = () => {
  return {
    type: RESET_PRODUCT_SELECTED
  }
}
export const createNewProduct = (form, token) => {
  const url = `${process.env.REACT_APP_URL}/crm/products`
  const headers = { Authorization: token }
  let payload = {}
  return async ( dispatch ) => {
    dispatch({ type: START_REQUEST_SEARCH })
    await axios.post(url, form, {headers}).then(resp => {
      payload = {
        type: CREATE_PRODUCT,
        payload: resp.data
      }
      dispatch(payload)
      dispatch({
        type: SET_SNACKBAR_SEARCH,
        payload: { message: 'El producto se a creado con éxito', color: 'success' }
      })
    }).catch(error => {
      const err = error.response?.data?.message?.error
      dispatch({
        type: SET_SNACKBAR_SEARCH,
        payload: { message: err ? err : 'Error en el servidor', color: 'danger' }
      })
    })
    dispatch({ type: STOP_REQUEST_SEARCH })
  }
}

export const editProduct = (id, form, token) => {
  const url = `${process.env.REACT_APP_URL}/crm/products/${id}`
  const headers = { Authorization: token }
  let payload = {}
  return async ( dispatch ) => {
    dispatch({ type: START_REQUEST_SEARCH })
    await axios.put(url, form, { headers }).then(resp => {
      payload = {
        type: MOD_PRODUCT,
        payload: resp.data
      }
      dispatch(payload)
      dispatch({
        type: SET_SNACKBAR_SEARCH,
        payload: { message: 'El producto se a modificado con éxito', color: 'success' }
      })
    }).catch(error => {
      const err = error.response?.data?.message?.error
      dispatch({
        type: SET_SNACKBAR_SEARCH,
        payload: { message: err ? err : 'Error en el servidor', color: 'danger' }
      })
    })
    dispatch({ type: STOP_REQUEST_SEARCH })
  }
}

//Por ahora no se necesita esta funcion
// export const deleteProduct = (id, token) => {
//   const url = `${process.env.REACT_APP_URL}/crm/products/${id}`
//   const headers = { Authorization: token } 
//   let payload = {}
//   return async ( dispatch ) => {
//     dispatch({ type: START_REQUEST_SEARCH })
//     await axios.delete(url, {headers}).then(resp => {
//       payload = {
//         type: DELETE_PRODUCT,
//         payload: TestData
//       }
//       dispatch(payload)
//       dispatch({
//          type: SET_SNACKBAR_SEARCH,
//          payload: { message: 'El producto se a modificado con éxito', color: 'success' }
//        })
//     }).catch(error => {
//       const err = error.response?.data?.message?.error
//       dispatch({
//         type: SET_SNACKBAR_SEARCH,
//         payload: { message: err ? err : 'Error en el servidor', color: 'danger' }
//       })
//       dispatch({
//         type: RESET_LOADING,
//       })
//     })
//   }
// }
